import { useEffect, useRef, useState } from 'react';
import { ExperimentState } from 'modules/graphql';
import { Tooltip } from 'ui/tooltip';

import { BaseCellWrapper, BodyText } from '../../styled';
import { ExperimentPopover } from '../../ExperimentPopover';

export const ExperimentNameCell = ({
  experimentName,
  experimentState,
  href,
}: {
  experimentName: string;
  experimentState: ExperimentState;
  href: string;
}) => {
  const [showPopover, setShowPopover] = useState(false);
  const labelRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const spanElement = labelRef.current;
    if (spanElement) {
      setIsTruncated(spanElement.offsetHeight < spanElement.scrollHeight);
    }
  }, []);

  return (
    <BaseCellWrapper>
      <Tooltip tooltipContent={experimentName} isEnabled={isTruncated && !showPopover}>
        <BodyText
          data-test="choose-campaign-experiment-label"
          onClick={() => setShowPopover(true)}
          onBlur={() => setShowPopover(false)}
        >
          <ExperimentPopover
            open={showPopover}
            experimentName={experimentName || ''}
            href={href}
            experimentNameRef={labelRef}
            experimentState={experimentState}
          />
        </BodyText>
      </Tooltip>
    </BaseCellWrapper>
  );
};
